import generateGroups from './generateGroups';

/**
 * @param {Object[]} items
 * @param {string} [title='Custom fields']
 * @returns {Object[][]}
 */
export default function createGroups(items, title = 'Custom fields') {
  return generateGroups(items, title);
}
